import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseCross = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.91615 4.99995L9.80995 1.10605C10.0634 0.852766 10.0634 0.443244 9.80995 0.189962C9.55667 -0.0633206 9.14714 -0.0633206 8.89386 0.189962L4.99994 4.08387L1.10614 0.189962C0.85274 -0.0633206 0.443335 -0.0633206 0.190051 0.189962C-0.0633505 0.443244 -0.0633505 0.852766 0.190051 1.10605L4.08385 4.99995L0.190051 8.89386C-0.0633505 9.14714 -0.0633505 9.55666 0.190051 9.80994C0.316278 9.93629 0.482246 9.99976 0.648097 9.99976C0.813947 9.99976 0.979797 9.93629 1.10614 9.80994L4.99994 5.91604L8.89386 9.80994C9.0202 9.93629 9.18605 9.99976 9.3519 9.99976C9.51775 9.99976 9.6836 9.93629 9.80995 9.80994C10.0634 9.55666 10.0634 9.14714 9.80995 8.89386L5.91615 4.99995Z",
		fill: "currentColor"
	})
});
export default SvgCloseCross;
